import { render, staticRenderFns } from "./ModalUnionEdit.vue?vue&type=template&id=7b0ad60b&scoped=true"
import script from "./ModalUnionEdit.vue?vue&type=script&lang=js"
export * from "./ModalUnionEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalUnionEdit.vue?vue&type=style&index=0&id=7b0ad60b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0ad60b",
  null
  
)

export default component.exports